// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    isDateFormat: true,

    TrustCRMApiHost: 'https://apiadmprece.prece.com.br/',
    TrustApiCobrancaHost: 'https://apicobranca.prece.com.br/',
    TrustApiMensagem: '',
    TrustapiAreaRestrita: 'https://apiarearestrita.prece.com.br/',
    TrustPastaImagens: 'https://arquivos.prece.com.br/imagens/', 
    TrustPastaImagensWebParticipante: 'https://arquivos.prece.com.br/DocumentosWebParticipante/',
    TrustPastaImagensEsteira: 'https://arquivos.prece.com.br/Documentos/',
    TrustCRMArHost: '',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
